import React, { Component } from 'react';
import { connect } from 'react-redux';
import { filter, startFilter } from '../../actions/api';
import HandsFreeSearch from '../../components/HandsFreeSearch';
import CategorySelector from '../../components/CategorySelector';
import SubcategorySelector from '../../components/SubcategorySelector';
import ClassificationSelector from '../../components/ClassificationSelector';
import InputRange from 'react-input-range';
import { searchOldUri } from '../../config/uri';

import { hideViewDetail } from '../../actions/product';
import styled from 'styled-components';
import { HeaderDiv, HeaderTitleDiv } from '../../pages';
import CloseIcon from '../CloseIcon';
import { BODY_TEXT_COLOR, THIRD_COLOR } from '../../config/colors';
import RaisedButton from 'material-ui/RaisedButton';
import { reset } from '../../actions/product';
import styles from './defaultStyles';
import { getHandFreeSearchParams, getFilterParams, mapAttributes } from './utils';
import 'react-input-range/lib/css/index.css';
import './slider.css';
import { pushWithQueryParams } from '../../services/uri';

const initialState = {
  mappedAttributes: { effects: [], attributes: []},
  selectedHandsFreeParams: [],
  selectedClassifications: [],
  selectedCategories: [],
  selectedSubCategories: [],
  selectedPriceRange: { min: 0, max: 150 },
  isClassificationSelectorOpened: false,
  isCatSelectorOpened: false,
  isSubCatSelectorOpened: false,
  autoCompleteValue: [],
}
class FilterBar extends Component {
  constructor(props) {
    super(props);
    this.autocompleteRef = null;
  }

  state = { ...initialState };

  handleHandsFreeChange = (values) => {
    const mappedAttributes = mapAttributes(values, { effects: this.props.config.effects });
    this.setState({
      selectedHandsFreeParams: values,
      mappedAttributes: mappedAttributes,
    })
  }

  handleClassificationChange = (values) => {
    this.setState({ selectedClassifications: values });
  }

  handleCategoryChange = (values) => {
    this.setState({ selectedCategories: values });
  }

  handleSubCategoryChange = (values) => {
    this.setState({ selectedSubCategories: values });
  }

  handleRemoveAttrClick = (attrybuteName) => {
   const index = this.state.selectedHandsFreeParams.indexOf(attrybuteName);
   const selectedHandsFreeParams = [...this.state.selectedHandsFreeParams];
   selectedHandsFreeParams.splice(index, 1);
   this.setState({ selectedHandsFreeParams: selectedHandsFreeParams });
  }
  
  renderAttributes = () => {
    const attributeMap = mapAttributes(this.state.selectedHandsFreeParams, { effects: this.props.config.effects });
    const effects =  attributeMap.effects; 
    const attributes = attributeMap.attributes; 
    if (attributes.length || effects.length) { 
     return (
       <div style={styles.splitter}>
        <AttributesContainerDiv>
          <AttributeWrapperDiv>
            <AttrSection>
              <AttributeTitleDiv>Effects</AttributeTitleDiv>
              {effects.map((effect, i) => (<ChipDiv key={i}><CloseIcon onClick={this.handleRemoveAttrClick.bind(null, effect)} color={THIRD_COLOR}/><ChipText>{effect}</ChipText></ChipDiv>))}
            </AttrSection>
          </AttributeWrapperDiv>
          <AttributeWrapperDiv>
            <AttrSection>
              <AttributeTitleDiv>Attributes</AttributeTitleDiv>
              {attributes.map((attr, i) => (<ChipDiv key={i}><CloseIcon onClick={this.handleRemoveAttrClick.bind(null, attr)} color={THIRD_COLOR}/><ChipText>{attr}</ChipText></ChipDiv>))}
            </AttrSection>
          </AttributeWrapperDiv>
        </AttributesContainerDiv>
      </div>
    )
    } else {
      return null;
    }
  }

  isSelected = () => {
    const {selectedHandsFreeParams, selectedClassifications, selectedCategories, selectedPriceRange,autoCompleteValue} = this.state;
    return autoCompleteValue.length 
      || selectedHandsFreeParams.length
      || selectedClassifications.length
      || selectedCategories.length
      || selectedPriceRange.min > 0
      || selectedPriceRange.max < 150;
  }

  reset = () => {
    this.setState(...this.state, initialState)
    this.autocompleteRef.setState({ searchText: '' });
  }

  handleClearClick = () => {
    this.reset();
  }

  getHandsFreeSearchText = () => {
    return this.state.selectedHandsFreeParams.length 
      ? this.state.selectedHandsFreeParams : this.toHandsFreeParams(this.state.autoCompleteValue)
  }

  toHandsFreeParams = (searchValues) => {
    if (!searchValues || !searchValues.length) return []
    return searchValues
      .filter(v => v.length)
      .map(v => {
        const valueInUpperCase = v.toUpperCase()
        return  { key: valueInUpperCase, label: valueInUpperCase }
    })
  }

  handleApplyClick = () => {
    if (!this.isSelected()) {
      // reset 
      this.props.reset();
      this.props.go(searchOldUri);
      return;
    }
    const params = {
      selectedCategories: this.state.selectedCategories,
      selectedClassifications: this.state.selectedClassifications,
      selectedPriceRange: this.state.selectedPriceRange,
      handsFreeParams: getHandFreeSearchParams(this.getHandsFreeSearchText(), this.props.config),
    }
    let filterParams = getFilterParams(params);
    if (this.state.selectedSubCategories.length > 0)
      filterParams = {...filterParams, subTypes: this.state.selectedSubCategories};
    
    this.props.filter(filterParams);

    if (this.props.detailView.isOpen) {
      this.props.hideViewDetail();
    }
    
    this.props.go(searchOldUri);
  }

  handleCatClick = () => {
    this.setState({ isCatSelectorOpened: !this.state.isCatSelectorOpened })
  }
  
  handleSubCatClick = () => {
    this.setState({ isSubCatSelectorOpened: !this.state.isSubCatSelectorOpened })
  }

  handelClassificationClick = () => {
    this.setState({ isClassificationSelectorOpened: !this.state.isClassificationSelectorOpened })
  }

  isSubCategories = () => {
     const catsWithSubCats = this.state.selectedCategories.filter(c => (this.props.config.subCat[c] || []).length > 0);
     return catsWithSubCats.length > 0;
  }

  onAutocompleteUpdate = (searchText) => {
    if (searchText) {
      this.setState({
        autoCompleteValue: searchText.split(' '),
      })
    }
  }

  setAutoCompleteRef = (ref) => {
    this.autocompleteRef = ref;
  }

  render() {
    const { secondaryColor } = this.props;
    return (
      <div className="filter-container">
        <HeaderDiv>
          <HeaderTitleDiv>SEARCH</HeaderTitleDiv> 
        </HeaderDiv>

        <SectionDiv> 
          <div style={styles.handsFreeWrapper}>
            <HandsFreeSearch 
              autocompleteRef={this.autocompleteRef}
              setRef={this.setAutoCompleteRef}
              onUpdate={this.onAutocompleteUpdate}
              config={this.props.config}
              selectedAttributes={this.state.selectedHandsFreeParams}
              onChange={this.handleHandsFreeChange} />
          </div>
        </SectionDiv>
        {/* render selected attributes from hands free search */}
        {this.renderAttributes()}
        
        <SectionDiv> 
          <div style={styles.selectorWrapper}> 
            <CategorySelector 
              onClick={this.handleCatClick} 
              isOpened={this.state.isCatSelectorOpened} 
              selectedItemColor={secondaryColor}
              bodyTextColor={BODY_TEXT_COLOR} 
              categories={this.props.config.categories} 
              selectedAttributes={this.state.selectedCategories} 
              onChange={this.handleCategoryChange} />
          </div>
        </SectionDiv>

        { this.isSubCategories() &&
          <SectionDiv> 
            <div style={styles.selectorWrapper}> 
              <SubcategorySelector 
                onClick={this.handleSubCatClick} 
                selectedCategories={this.state.selectedCategories} 
                isOpened={this.state.isSubCatSelectorOpened} 
                selectedItemColor={secondaryColor} 
                bodyTextColor={BODY_TEXT_COLOR} 
                subcategories={this.props.config.subCat} 
                selectedAttributes={this.state.selectedSubCategories} 
                onChange={this.handleSubCategoryChange} />
            </div>
          </SectionDiv>
        }

        <SectionDiv> 
          <div style={styles.selectorWrapper}> 
            <ClassificationSelector 
              onClick={this.handelClassificationClick} 
              isOpened={this.state.isClassificationSelectorOpened} 
              colors={this.props.config.colors} 
              selectedItemColor={secondaryColor} 
              bodyTextColor={BODY_TEXT_COLOR} 
              brightBodyTextColor="#FFF"
              classifications={this.props.config.classifications} 
              selectedAttributes={this.state.selectedClassifications} 
              onChange={this.handleClassificationChange} />
          </div>
        </SectionDiv>

        <div style={styles.priceWrapper}> 
          <div style={styles.priceHeader}>Price</div>
          <div style={styles.slider}>
            <InputRange
              maxValue={150}
              minValue={0}
              formatLabel={value => `$ ${value}`}
              value={this.state.selectedPriceRange}
              onChange={value => this.setState({ selectedPriceRange: value })}
            />
          </div>
         </div>

        <div style={{width: '270px', margin: '20px auto'}}>
          <ButtonsWrapperDiv>
            <RaisedButton
                disabled={!this.isSelected()}
                onClick={this.handleClearClick}
                backgroundColor={styles.secondaryButtonColor}
                labelColor="#FFF"
                label="Clear"
                labelStyle={styles.labelStyle}
                style={styles.button}
              />
            <RaisedButton
                onClick={this.handleApplyClick}
                backgroundColor={secondaryColor}
                labelColor="#FFF"
                labelStyle={styles.labelStyle}
                label="Search"
                style={styles.button}
              />
          </ButtonsWrapperDiv>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    detailView : state.detailView,
    secondaryColor: '#' + state.config.secondaryColor,
    config : state.config,
  };
};

const mapDispatchToProps = (dispatch) => {
  return { 
    hideViewDetail : () => dispatch(hideViewDetail()),
    filter : (filterParams) => dispatch(startFilter(filterParams)),
    go: (uri) => dispatch(pushWithQueryParams(uri)),
    reset: () => dispatch(reset()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FilterBar);

const ButtonsWrapperDiv = styled.div `
  display: flex;
  justify-content: space-between;
`;

const AttributesContainerDiv = styled.div `
    display: flex;
    width: 290px;
    margin: 0 auto;
`;

const ChipDiv = styled.span `
    height: 34px;
    line-height: 34px;
    cursor: pointer;
    border: 2px solid #E6E6E7;
    padding: 0 15px 0 7px;
    margin-bottom: 5px;
    border-radius: 20px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    color: #616161;
`;

const ChipText = styled.span ` 
    max-width : 120px;
    overflow:hidden;
    display:inline-block;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: ${BODY_TEXT_COLOR};
`;

const AttributeWrapperDiv = styled.div `
    width: 50%;
`;
 
const AttributeTitleDiv = styled.div `
  font-size: 16px;
  padding: 15px 0;
  color: ${BODY_TEXT_COLOR};
`;

const AttrSection = styled.div `
`;

 const SectionDiv = styled.div `
    width: 350px;
    margin: 0 auto;
    padding-bottom: 10px;
    border-bottom: 1px #e6e6e6 solid;
    @media (max-width: 641px) {
      width: 95%;
    }
`;




// WEBPACK FOOTER //
// ./src/components/FilterBar/FilterBar.jsx